// URL del backend: en localhost usa puerto 8000; en cualquier otro host usa el mismo origen
// (funciona tanto con ngrok, duckdns, como con IP directa sin cambios)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:8000'
    : window.location.origin);

const API = `${BACKEND_URL}/api`;
const WS_URL = BACKEND_URL.replace(/^http/, 'ws') + '/ws/prices';

export { BACKEND_URL, API, WS_URL };
